import { useEffect, useRef, useState } from 'react';

/**
 * The value once it has stopped changing for `delayMs`: what a live preview asks the server for, so it draws once a
 * person pauses rather than on every key (Admin redesign 2026-11-02). Compared by content, so a new object with the
 * same contents neither restarts the wait nor counts as a change.
 */
export function useSettledValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);
  const latest = useRef(value);
  const key = JSON.stringify(value);
  const settledKey = JSON.stringify(settled);
  useEffect(() => {
    latest.current = value;
  });
  useEffect(() => {
    if (key === settledKey) return undefined;
    const timer = window.setTimeout(() => setSettled(latest.current), delayMs);
    return () => window.clearTimeout(timer);
  }, [key, settledKey, delayMs]);
  return settled;
}
